module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-badge",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('div', {
    staticClass: "page-badge-container"
  }, [_c('div', {
    staticClass: "page-badge-part"
  }, [_c('mt-badge', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "danger",
      "size": "small"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "warning",
      "size": "small"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "size": "small",
      "color": "#888",
      "fontColor": "red",
      "fontSize": "18px"
    }
  }, [_vm._v("自定义颜色")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-badge-part"
  }, [_c('mt-badge', {
    attrs: {
      "type": "primary",
      "size": "normal"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "danger",
      "size": "normal"
    }
  }, [_vm._v("new")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "success",
      "size": "normal"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "warning",
      "size": "normal"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "size": "normal",
      "color": "#888"
    }
  }, [_vm._v("自定义颜色")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-badge-part"
  }, [_c('mt-badge', {
    attrs: {
      "type": "primary",
      "size": "large"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "danger",
      "size": "large"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "success",
      "size": "large"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "warning",
      "size": "large"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "size": "large",
      "color": "#888"
    }
  }, [_vm._v("自定义颜色")])], 1)]), _vm._v(" "), _c('mt-cell-group', [_c('mt-cell', {
    attrs: {
      "title": "徽章"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("未读消息")]), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "type": "danger",
      "size": "small"
    }
  }, [_vm._v("10")])], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "红点标识"
    }
  }, [_c('mt-badge', {
    attrs: {
      "size": "normal",
      "padding": "3px",
      "color": "red"
    }
  })], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "'卷'"
    }
  }, [_c('mt-badge', {
    attrs: {
      "size": "normal",
      "padding": "3px",
      "color": "#FFB950",
      "radius": "2px"
    }
  }, [_vm._v("卷")])], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "自动缴费"
    }
  }, [_c('mt-badge', {
    attrs: {
      "padding": "4px",
      "color": "#FFF",
      "fontColor": "#FFB950",
      "bColor": "#FFB950",
      "radius": "2px"
    }
  }, [_vm._v("自动缴费")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cbf1ca0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/badge.vue
// module id = 99
// module chunks = 0